export default "__VITE_ASSET__CUSQUZnz__"